module.exports = __webpack_public_path__ + "img/dma.46f58d40.svg";